import { render, staticRenderFns } from "./PostIt.vue?vue&type=template&id=0b7d2a6e&lang=pug&"
import script from "./PostIt.vue?vue&type=script&lang=js&"
export * from "./PostIt.vue?vue&type=script&lang=js&"
import style0 from "./PostIt.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b7d2a6e')) {
      api.createRecord('0b7d2a6e', component.options)
    } else {
      api.reload('0b7d2a6e', component.options)
    }
    module.hot.accept("./PostIt.vue?vue&type=template&id=0b7d2a6e&lang=pug&", function () {
      api.rerender('0b7d2a6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/editor/schematic/blocs/PostIt.vue"
export default component.exports